import vue from 'vue'
import { Popup,Toast } from 'vant';

vue.use(Popup)
vue.use(Toast)